// BottomSheet.js
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import {
  Close as CloseIcon,
  Add as AddIcon,
  Remove as RemoveIcon,
} from "@mui/icons-material";

import { useBottomSheet } from "./BottomSheetContext";

const BottomSheet = () => {
  const { isOpen, openBottomSheet, closeBottomSheet } = useBottomSheet();
  const [isMobile, setIsMobile] = useState(false);
  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleButtonClick = () => {
    closeBottomSheet();
  };

  const handleIncrementQuantity = () => {
    setQuantity((prevQuantity) => prevQuantity + 1);
  };

  const handleDecrementQuantity = () => {
    setQuantity((prevQuantity) => Math.max(1, prevQuantity - 1));
  };

  return (
    <SwipeableDrawer
      anchor="right"
      open={isOpen}
      onClose={closeBottomSheet}
      onOpen={openBottomSheet}
      swipeAreaWidth={20}
      disableSwipeToOpen={false}
      disableBackdropTransition={true}
      PaperProps={{
        sx: {
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          backgroundColor: "#FFFFFF",
        },
      }}
    >
      <Box>
        <Box
          sx={{ backgroundColor: "#E0E0E0", width: "100%", height: "6px" }}
        />
        <Box
          sx={{
            backgroundColor: "#EEEEEE",
            height: "12px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              backgroundColor: "#B6B6B6",
              width: "100px",
              height: "6px",
              borderRadius: "20px",
            }}
          />
        </Box>
        {!isMobile && (
          <Box
            sx={{
              backgroundColor: "#EEEEEE",
              height: "10px",
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
            }}
          >
            <IconButton
              size="small"
              sx={{
                backgroundColor: "#EEEEEE",
                marginRight: 3,
                marginTop: 2,
              }}
              onClick={handleButtonClick}
            >
              <CloseIcon sx={{ color: "#636363" }} />
            </IconButton>
          </Box>
        )}
      </Box>
      <Box>Hello Bottomsheet</Box>
    </SwipeableDrawer>
  );
};

export default BottomSheet;
